import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useCallback } from 'react'

type SendFrequencyToggleEventParams = {
  frequency?: string
  experiment_id?: string | null
  feature?: string | null
  current_plan?: string | null
  from_component?: string | null
  modal_type?: string | null
  pid?: number | null
}

export const useSendFrequencyToggleEvent = () => {
  const sendFrequencyToggleEvent = useCallback(
    ({
      experiment_id,
      feature,
      current_plan,
      from_component,
      modal_type,
      pid,
      frequency,
    }: SendFrequencyToggleEventParams) => {
      if (!pid) return

      sendMetrics('Box.FrequencyToggleClicked', String(pid), {
        experiment_id,
        feature,
        current_plan,
        from_component,
        modal_type,
        frequency,
      })
    },
    []
  )

  return { sendFrequencyToggleEvent }
}
